import { ReactComponent as BfcmIcon } from "../imgComponents/bfcm.svg";
import { ReactComponent as MakeIcon } from "../imgComponents/make.svg";
import "../../css/inner-page/sectionCta.scss";
import CTA from "../CTA";
import { useLocation } from "react-router-dom";

export default function Section(props) {
  const location = useLocation();
  return (
    <section id="cta">
      {location.pathname === "/during" && (
        <div className="icon bfcm-icon" data-aos="fade">
          <BfcmIcon />
        </div>
      )}

      {location.pathname === "/after" && (
        <div className="icon make-icon" data-aos="fade">
          <MakeIcon />
        </div>
      )}

      <div
        data-aos="fade"
        className="cta-background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/outline-bg.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      ></div>
      <h2>{props.title}</h2>
      <CTA href={props.cta.url} title={props.cta.title} icon="arrow-right" segmentLocation="RAD middle page" />
    </section>
  );
}
